import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { message, Modal } from 'ant-design-vue';
import { delete_product_out_record, get_product_in_record } from '@/api/mjstock-model';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import base_info from '@/components/info-modal/base_info_modal';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '详情',
    type: 'dropdown',
    clazz: '',
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      get_product_in_record({
        org_id: current_org?.id,
        product_in_record_id: record.product_in_record_id,
      }).then(function (res: any) {
        base_info(
          '入库产品信息',
          '入库编号:' + res.code,
          [
            { name: '存货编号', value: 's_product__code' },
            { name: '存货名称', value: 's_product__name' },
            { name: '存货规格', value: 's_product__gg' },
            { name: '存货单位', value: 's_product__dw' },
            { name: '产品批次', value: 'product_code' },
            { name: '存货单价', value: 'single_price' },
            { name: '生产日期', value: 'product_date' },
            { name: '到期日期', value: 'end_date' },
            { name: '厂商', value: 'product_company__name' },
            { name: '供货商', value: 'supply_company__name' },
          ],
          res,
        );
      });
    },
  },
  {
    name: '作废',
    type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: '是否作废这条记录[' + record.code + ']',
        onOk() {
          delete_product_out_record({
            product_out_record_id: record.id,
            org_id: current_org?.id,
          }).then(function (res) {
            message.success('作废成功');
            Object.assign(record, res);
          });
        },
        onCancel() {},
      });
    },
  },
  // {
  //   name: '出库退货',
  //   clazz: '',
  //   cb: (record: any) => {
  //     // 模态框，确认按钮点击。
  //     const editModal = reactive({
  //       visible: true,
  //       title: '创建出库退货记录',
  //       form: {
  //         settings: {
  //           labelAlign: 'right',
  //           layout: 'horizontal',
  //           col: [8, 8],
  //         },
  //         fields: [
  //           {
  //             type: 'remotemodal',
  //             name: 'product_out_record_id',
  //             label: '关联出库单据',
  //             disabled: true,
  //             placeholder: '请选择关联出库单据',
  //             datasourceType: 'remote',
  //             labelKey: 'code',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstock-productoutrecord',
  //           },
  //           {
  //             type: 'remotemodal',
  //             name: 'order_used_record_id',
  //             label: '关联出库耗单',
  //             disabled: true,
  //             placeholder: '请选择关联出库耗单',
  //             datasourceType: 'remote',
  //             labelKey: 'code',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-orderusedrecord',
  //           },
  //           {
  //             type: 'input',
  //             name: 's_product__code',
  //             label: '产品编码',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 's_product__name',
  //             label: '产品编码',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 's_product__gg',
  //             label: '产品规格',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 's_product__dw',
  //             label: '产品单位',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 'out_num',
  //             label: '出货数量',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 'cancel_num',
  //             label: '退货数量',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 'single_price',
  //             label: '产品单价',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'input',
  //             name: 'cancel_price',
  //             label: '产品金额',
  //             disabled: true,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //           },
  //           {
  //             type: 'remotemodal',
  //             name: 'from_shop_id',
  //             label: '调拨来源',
  //             disabled: true,
  //             placeholder: '请选择调拨来源',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-shop',
  //           },
  //           {
  //             type: 'remotemodal',
  //             name: 'transfer_code',
  //             label: '调拨编号',
  //             disabled: true,
  //             placeholder: '请选择调拨来源',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-shop',
  //           },
  //           {
  //             type: 'datepicker',
  //             name: 'cancel_datetime',
  //             label: '退货日期',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'number',
  //             defaultValue: '',
  //             showTime: true,
  //             placeholder: '请填写出库日期',
  //           },
  //           {
  //             type: 'remoteselect',
  //             name: 'shop_id',
  //             label: '执行门店',
  //             disabled: true,
  //             placeholder: '请选择执行门店',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-shop',
  //           },
  //           {
  //             type: 'remoteselect',
  //             name: 'staff_id',
  //             label: '执行人',
  //             disabled: false,
  //             placeholder: '请选择执行人',
  //             datasourceType: 'remote',
  //             mode: 'default',
  //             allowClear: true,
  //             modalType: 'mjstore-staff',
  //           },
  //           {
  //             type: 'input',
  //             name: 'cancel_reason',
  //             label: '退库原因',
  //             disabled: false,
  //             allowClear: true,
  //             inputType: 'text',
  //             defaultValue: '',
  //           },
  //         ],
  //         rules: {
  //           cancel_num: [{ required: true, message: '请输入入库产品数量' }],
  //           product_out_record_id: [{ required: true, message: '请选择产品' }],
  //           cancel_datetime: [{ required: true, message: '请选择入库日期' }],
  //           staff_id: [{ required: true, message: '请选择执行人' }],
  //           cancel_reason: [{ required: true, message: '请填写退库原因' }],
  //         },
  //         model: reactive({
  //           org_id: current_org?.id,
  //           product_out_record_id: record.id,
  //           ...record,
  //           staff_id: null,
  //         }),
  //         watch: {
  //           cancel_num: (data: any) => {
  //             data.cancel_price = data.single_price * data.cancel_num;
  //           },
  //         },
  //       },
  //       options: {},
  //       ok: (payload: any) => {
  //         if (Number(payload.cancel_num) <= 0 && Number(payload.cancel_num) > payload.remain_num) {
  //           notification.error({
  //             message: '输入数值错误',
  //             description: '退货数量要大于0,且小于出库数量',
  //           });
  //           return false;
  //         }
  //         create_product_out_cancel_record(payload).then(() => {
  //           message.success('出库退货记录创建成功');
  //           event_obj.emit('refresh');
  //         });
  //       },
  //     });
  //     modalBox(editModal);
  //   },
  // },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
